import styled from "styled-components";

export const AvatarCircle = styled.div<{ $size?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ $size }) => $size || 36}px;
  height: ${({ $size }) => $size || 36}px;
  border-radius: 50%;
  background: rgba(0, 255, 194, 0.15);
  color: #00ffc2;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1;
  user-select: none;
`;
